import axios from 'axios';
import { HistoricalOrder } from 'views/order-feed/features/order-history/types/historical-order.type';
import { GetHistoricalOrdersInput } from 'views/order-feed/features/order-history/types/get-historical-orders-input.type';

// GET
// /ewosapi/v1/order/analytics/{globalCompanyId}/purchasehistory
export const getDetailedOrderHistory = async (
  globalCompanyId: string,
  getOrderHistory: GetHistoricalOrdersInput
): Promise<HistoricalOrder[]> => {
  const res = await axios.post(`/ewosapi/v1/order/analytics/${globalCompanyId}/orderhistory/detailed`, getOrderHistory);
  return res.data;
};
